import React from 'react';

export function Card({ children, className = '', padding = true, ...props }) {
  return (
    <div
      className={['bg-white rounded-xl border border-gray-200 shadow-sm', padding ? 'p-5' : '', className].join(' ')}
      {...props}
    >
      {children}
    </div>
  );
}

export function CardHeader({ title, subtitle, action, className = '' }) {
  return (
    <div className={['flex items-start justify-between mb-4', className].join(' ')}>
      <div>
        <h3 className="text-base font-semibold text-gray-900">{title}</h3>
        {subtitle && <p className="text-sm text-gray-500 mt-0.5">{subtitle}</p>}
      </div>
      {action && <div className="ml-4 flex-shrink-0">{action}</div>}
    </div>
  );
}

export default Card;
